import { Link } from '@adobe/react-spectrum';
import React, { useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { LinkButton } from '@exchange-frontends/components';
import { getCorrectUrlSlug } from '@exchange-frontends/utils';

import { ROUTES } from '../../../../constants';
import { useStore } from '../../store';
import { AppDetailsContext } from './AppDetails';

const ViewAllLink = ({ showAllApps, onViewAll, onViewLess }) => {
  const { cloud } = useContext(AppDetailsContext);
  const detailScreen = useStore((state) => state.detailScreen);
  const isSolution = detailScreen?.appType === 'SLN';

  if (isSolution && !showAllApps) {
    return (
      <LinkButton aria-label="View all apps by this partner" onPress={onViewAll} styleProps={{ variant: 'secondary' }}>
        View all
      </LinkButton>
    );
  } else if (isSolution && showAllApps) {
    return (
      <LinkButton
        onPress={onViewLess}
        styleProps={{ variant: 'secondary' }}
        aria-label="View less apps by this partner"
      >
        View less
      </LinkButton>
    );
  } else {
    const publisherId = detailScreen?.publisher?.id;
    const publisherName = detailScreen?.publisher?.name;
    const publisherNameSlug = getCorrectUrlSlug(publisherName);
    const publisherURL = `${ROUTES.PUBLISHER}/${cloud}/${publisherId}/${publisherNameSlug}`;

    return (
      <Link variant="secondary" aria-label="View all apps by this publisher">
        <RouterLink to={publisherURL}>View all</RouterLink>
      </Link>
    );
  }
};

export default ViewAllLink;
